// extracted by mini-css-extract-plugin
export default {"btn_close":"Toast_btn_close__cny5O","btn_close_img":"Toast_btn_close_img__YXBI3","toast_content":"Toast_toast_content__qeuJV","toast_section":"Toast_toast_section__Fm4Av"};